
import Q2DeskCards from "./q2_desk_cards";
import PokerTablePokerBase from "../../../table/module/poker_table/poker_table_poker_base";
import { Card } from "./q2_card_common";
import { HorizontalDirection, VerticalDirection } from "../../../table/module/poker_table/poker_seat_pokers_base";

const { ccclass, property, menu } = cc._decorator;

export enum SelectState{
    Normal = 0,
    Disable = 1,
    Selected = 2,
}

@ccclass
export default class Q2DeskAreaCardsPattern extends Q2DeskCards{

    @property(cc.Sprite)
    spriteOutLine: cc.Sprite = null

    @property(cc.Float)
    outLineWidthOffset: number = 0

    @property(cc.Node)
    nodeRaiseAnim: cc.Node = null

    @property(cc.Node)
    nodeStorageAnim: cc.Node = null

    @property(cc.Node)
    nodeAttachAnim: cc.Node = null

    get pattern_selected_state(): SelectState{
        return this.m_pattern_select_state
    }

    set pattern_selected_state(val: SelectState){
        this.m_pattern_select_state = val
    }

    getPokers(){
        return this.pokers.concat()
    }

    protected m_pattern_select_state: SelectState = SelectState.Normal
    protected m_on_click_callback: Function = null
    protected m_originalParent: cc.Node = null
    protected m_selectParent: cc.Node = null

    setOriginalParent(parent: cc.Node){
        this.m_originalParent = parent
        this.node.parent = parent
    }    

    setSelectParent(parent: cc.Node){
        let lastSelectParent = this.m_selectParent        
        this.m_selectParent = parent        
        if(lastSelectParent == this.node.parent){
            this.resetParent(parent)
        }
    }

    reset(){
        super.reset()
        this.resetParent()
        this.showOutLine(false)
        this.showMask(false)        
    }

    protected resetParent(parent?: cc.Node){
        if(parent && parent != this.m_originalParent){            
            parent.position = parent.parent.convertToNodeSpaceAR(this.m_originalParent.parent.convertToWorldSpaceAR(this.m_originalParent.position))  
            this.node.parent = parent
            this.node.position = cc.Vec2.ZERO    
            this.node.scale = 1      
            return
        }
        if(!this.m_originalParent){
            return
        }
        this.node.parent = this.m_originalParent
        this.node.position = cc.Vec2.ZERO
    }

    refreshPatternSelectState(){
        let self = this
        let duration = 0.2
        switch (this.m_pattern_select_state) {
            case SelectState.Normal:
                self.resetParent()
                self.showOutLine(false)
                self.showMask(false)
                self.playNodeAnim(this.node, this.node.position, cc.Vec2.ONE, duration, null, null, null, null, true)                
                break;
            case SelectState.Disable:
                self.resetParent()
                self.showOutLine(false)
                self.showMask(true)
                self.playNodeAnim(this.node, this.node.position, cc.Vec2.ONE, duration, null, null, null, null, true)                
                break;
            case SelectState.Selected:
                self.resetParent(self.m_selectParent)
                self.showOutLine(true)
                self.showMask(false)
                self.playNodeAnim(this.node, this.node.position, cc.Vec2.ONE.mul(1.2), duration, null, null, null, null, true)
                break;
            default:
                break;
        }
    }



    playCardOutAnim(codeList: number[], onFinish?: Function){
        
    }

    playCardInAnim(codeList: number[], onFinish: Function, params?: any){
        let self = this                
        let appendPokers = self.genPokerList(codeList, true)
        let pokers = this.pokers
        self.sortPokerListByIndex(pokers, params.codeList)

        let tmpCodeList = codeList.concat()
        for (let index = 0; index < pokers.length; index++) {
            const poker = pokers[index];
            for (let i = 0; i < appendPokers.length; i++) {
                const tmpPoker = appendPokers[i];
                if(poker == tmpPoker){
                    poker.showFace(poker.code != 0)
                    poker.showBack(poker.code == 0)
                    let posData = self.getPosData(index, pokers.length)
                    posData.localPos.y = this.startPosOffset
                    poker.node.position = posData.localPos
                    tmpCodeList.splice(i, 1)
                    self.playFadeAnim(poker.node, 0, 255, this.defaultAdjustDuration)
                    break
                }
            }
        }
        this.nodeRaiseAnim.parent.zIndex = this.pokers.length + 1
        this.playAdjust(null, function(){
            self.showAnimByType(params.type, null)            
            if(params.fromCompleteProcess){
                self.scheduleOnce(function(){
                    onFinish && onFinish()
                }, 1 - self.defaultAdjustDuration)
            }else{
                onFinish && onFinish()
            }
        })
    }

    setClickListener(callback: Function){
        this.m_on_click_callback = callback
    }

    protected showAnimByType(type: number, onFinish?: Function){
        this.nodeRaiseAnim.active = type == 1
        this.nodeStorageAnim.active = type == 2
        this.nodeAttachAnim.active = type == 3
        this.scheduleOnce(()=>{
            this.nodeRaiseAnim.active = false
            this.nodeStorageAnim.active = false 
            this.nodeAttachAnim.active = false    
            onFinish && onFinish()
        }, 1.9)
    }

    protected showOutLine(show: boolean){
        this.spriteOutLine.node.active = !!show
        if(show){
            let posData = this.calcPosAndAngle(this.pokers.length - 1, this.pokers.length)
            let width = posData.localPos.x + this.prefabPoker.node.width
            this.spriteOutLine.node.width = width + this.outLineWidthOffset
            this.spriteOutLine.node.zIndex = posData.zIndex + 1
        }
    }

    protected showMask(show: boolean){
        for (let index = 0; index < this.pokers.length; index++) {
            const poker = this.pokers[index];
            this.setPokerGrayColor(poker, !!show)
        }
    }

    protected on_drag(){

    }

    protected on_press(){

    }

    protected on_press_up(){

    }

    protected on_click(){
        if(this.m_pattern_select_state == SelectState.Normal){
            this.m_on_click_callback && this.m_on_click_callback(this)
        }         
    }

    protected calcPos(col: number, row: number, totalColCount: number, totalRowCount: number): cc.Vec2{           
        //最上面为第0行，最左边为第0列
        let centerCol = ((totalColCount - 1) * 0.5)
        let centerRow = ((totalRowCount - 1) * 0.5)
        let pos = cc.v2(0, 0)
        let intervalX = this.getIntervalX(totalColCount, totalRowCount)
        pos.x = intervalX * col
        if(this.horizontalDirection == HorizontalDirection.CenterToMargin){
            pos.x = intervalX * (col - centerCol)
        }else if(this.horizontalDirection == HorizontalDirection.LeftToRight){
            pos.x = intervalX * col
        }else if(this.horizontalDirection == HorizontalDirection.RightToLeft){
            pos.x = intervalX * (col - (totalColCount - 1))
        }
        pos.x += this.getOffsetX(totalColCount, totalRowCount)
        if(intervalX < this.intervalX){
            let colList = [0, 1, totalColCount - 2, totalColCount - 1]            
            
            let extendCount = colList.length - 1            
            let tmpOffset = this.intervalX - intervalX
            let extendOffset = tmpOffset * extendCount
            extendOffset = extendOffset / (totalColCount - colList.length - 0)
            for (let index = 0; index < colList.length; index++) {
                const tmpCol = colList[index];
                if(col > tmpCol){
                    pos.x += tmpOffset
                }                
            }
            if(col > 2 && col < totalColCount - 1){
                pos.x -= (extendOffset * (col - 2))
            }else if(col >= totalColCount - 1){
                pos.x -= tmpOffset * extendCount
            }
        }

        let intervalY = this.getIntervalY(totalColCount, totalRowCount)
        pos.y = intervalY * row
        if(this.verticalDirection == VerticalDirection.CenterToMargin){
            pos.y = intervalY * (centerRow - row)
        }else if(this.verticalDirection == VerticalDirection.TopToBottom){
            pos.y = intervalY * (-row)
        }else if(this.verticalDirection == VerticalDirection.BottomToTop){
            pos.y = intervalY * ((totalRowCount - 1) - row)
        }
        pos.y += this.getOffsetY(totalColCount, totalRowCount)
        if(intervalY < this.intervalY){
            if(row != 0){
                pos.y -= this.intervalY - intervalY
            }
        }
        return pos
    }

    protected sortPokerListByIndex(pokerList: PokerTablePokerBase[], codeList: number[]){
        let tmpIndexMap: any = {}
        for (let index = 0; index < codeList.length; index++) {
            let code = codeList[index];
            code = Card.codeToLogicCode(code)
            tmpIndexMap[code] = index
        }

        pokerList.sort(function(a, b){
            let aIndex = tmpIndexMap[Card.codeToLogicCode(a.code)]
            let bIndex = tmpIndexMap[Card.codeToLogicCode(b.code)]
            return aIndex - bIndex
        })
    }
   
}
